import React, { useCallback, useMemo } from "react";

import { Activity } from "@mapmycustomers/shared/types/entity";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import FormattedLongContentParagraph from "@app/component/typography/FormattedLongContentParagraph";
import { LongContentParagraphMode } from "@app/component/typography/LongContentParagraph";
import getActivityAllowedUsers from "@app/util/activity/getActivityAllowedUsers";

import styles from "./ActivityNotePreview.module.scss";

interface Props {
  activity: Activity;
  className?: string;
  currentUserId: User["id"];
  mode?: LongContentParagraphMode;
  note: string;
  rows?: number;
  teams: Team[];
  users: User[];
}

const ActivityNotePreview = ({
  activity,
  className,
  currentUserId,
  mode,
  note,
  rows = 5,
  teams,
  users,
}: Props) => {
  const allowedEmails: User["username"][] = useMemo(
    () =>
      getActivityAllowedUsers(
        currentUserId,
        users,
        activity.userIds ?? [],
        activity.visibility,
        activity.teamId ?? [],
        activity.assignee
      ),
    [
      activity.assignee,
      activity.teamId,
      activity.userIds,
      activity.visibility,
      currentUserId,
      users,
    ]
  );

  const handleIsMentionDisabled = useCallback(
    (user: User) => {
      return !allowedEmails.includes(user.username);
    },
    [allowedEmails]
  );

  return (
    <FormattedLongContentParagraph
      className={className}
      lexerProps={{ isMentionDisabled: handleIsMentionDisabled, teams, users }}
      mode={mode}
      noMargin
      paragraphClassName={styles.note}
      rows={rows}
    >
      {note}
    </FormattedLongContentParagraph>
  );
};

export default ActivityNotePreview;
